const C = {
  name: "SkipUp",
  dimensions: { width: 10, height: 10 },
  content: `
        <path d="M1 0C0.447716 0 1.51805e-07 0.447715 1.51805e-07 1C1.51805e-07 1.55228 0.447716 2 1 2H9C9.55229 2 10 1.55228 10 1C10 0.447715 9.55229 0 9 0H1Z" fill="currentColor"/>
        <path d="M5 6.41421L8.29289 9.70711C8.68342 10.0976 9.31658 10.0976 9.70711 9.70711C10.0976 9.31658 10.0976 8.68342 9.70711 8.29289L5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289L0.292894 8.29289C-0.0976312 8.68342 -0.0976312 9.31658 0.292894 9.70711C0.683417 10.0976 1.31658 10.0976 1.70711 9.70711L5 6.41421Z" fill="currentColor"/>
`
};
export {
  C as SkipUp
};
